import React from "react";
import { Navbar, Row, Col } from "react-bootstrap";
import Logo from "./Logo";

export default ({ MenuComponent }) => {
  return (
    <header id="admin-menu" className="header">
      <Navbar collapseOnSelect className="main-nav">
        <Row>
          <Col xs={12} md={4}>
            <Navbar.Header>
              <Logo />
              <Navbar.Toggle />
            </Navbar.Header>
          </Col>
          <Col xs={12} md={8}>
            <MenuComponent />
          </Col>
        </Row>
      </Navbar>
    </header>
  );
};



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/Header.js